import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
});
